import { TextInput, SelectInput, ImageInput, required } from 'react-admin'
import Grid from '@mui/material/Grid'

import CustomImageField from '../../components/CustomImageField'
import GridContainer from '../../components/GridContainer'
import RichTextInput from '../../components/RichTextInput'

const PlaylistInfoTab = () => {
  return (
    <GridContainer>
      <Grid item xs={12} md={6}>
        <TextInput
          source="name"
          label="Name"
          fullWidth
          validate={required()}
          variant="standard"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <SelectInput
          source="status"
          label="Status"
          choices={[
            { id: 'active', name: 'Active' },
            { id: 'inactive', name: 'Inactive' },
            { id: 'draft', name: 'Draft' },
          ]}
          fullWidth
          validate={required()}
          variant="standard"
        />
      </Grid>

      <Grid item xs={12}>
        <RichTextInput
          source="description"
          label="Description"
          fullWidth
          multiline
          rows={6}
          variant="standard"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <ImageInput
          source="backgroundImageUrl"
          label="Background Image"
          accept="image/*"
          placeholder={<p>Drop your image here</p>}>
          <CustomImageField source="src" title="title" />
        </ImageInput>
      </Grid>
    </GridContainer>
  )
}

export default PlaylistInfoTab
